import { render, staticRenderFns } from "./create-law.vue?vue&type=template&id=69f4f7a2&"
import script from "./create-law.vue?vue&type=script&lang=js&"
export * from "./create-law.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports